import {
  IconButton as LibIconButton,
  IconButtonProps as LibIconButtonProps,
} from "@flaminem/ui-components";
import { FC } from "react";

export type IconButtonProps = LibIconButtonProps;

export const IconButton: FC<IconButtonProps> = ({ children, ...props }) => {
  return <LibIconButton {...props}>{children}</LibIconButton>;
};
